import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type MessageBubbleTone = 'sent' | 'received';

interface MessageBubbleProps {
    children: React.ReactNode;
    tone?: MessageBubbleTone;
    fullWidth?: boolean;
    className?: string;
}

export function MessageBubble({ children, tone = 'sent', fullWidth, className }: MessageBubbleProps) {
    return (
        <Bubble $tone={tone} $fullWidth={!!fullWidth} className={className}>
            {children}
        </Bubble>
    );
}

const Bubble = styled('div', { shouldForwardProp: (p) => p !== '$tone' && p !== '$fullWidth' })<{
    $tone: MessageBubbleTone;
    $fullWidth: boolean;
}>(({ $tone, $fullWidth }) => ({
    maxWidth: $fullWidth ? '100%' : '65%',
    padding: '12px 16px',
    borderRadius: 12,
    backgroundColor: $tone === 'sent' ? Colors.primary : Colors.surface,
    color: $tone === 'sent' ? Colors.white : Colors.primary,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
}));
